import styled from 'styled-components';

export const Container = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const RetryMessage = styled.div`
  color: #262626;
  text-align: center;
`;
